module.exports = __webpack_public_path__ + "img/n1.16694c81.jpg";